import { useQuery } from "react-query";
import CompanyScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useState } from "react";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";
import {
  ICreateAndUpdateCompany,
  IRequestCompany,
} from "../../../types/company.interface";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedCompany, setSelectedCompany] =
    useState<ICreateAndUpdateCompany>();
  const [requestCompany, setRequestCompany] = useState<IRequestCompany>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });

  const resultCompany = useQuery(
    [values.useQueryKeys.getAllCompany, requestCompany],
    () =>
      api.postMethod.administrator.getAllCompany({
        ...requestCompany,
      })
  );

  const updateCompany = async (company: ICreateAndUpdateCompany) => {
    setLoading(true);
    const result = await api.putMethod.administrator.updateCompany(company);
    if (result) {
      resultCompany.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  const createCompany = async (CompanyInfo: ICreateAndUpdateCompany) => {
    setLoading(true);
    const result = await api.postMethod.administrator.createCompany(
      CompanyInfo
    );
    if (result) {
      resultCompany.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };
  const removeCompany = async (_id: string) => {
    setLoading(true);
    const result = await api.deleteMethod.administrator.deleteCompany(_id);
    if (result) {
      resultCompany.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
    return true;
  };

  return (
    <Context.CompanyScreen.Provider
      value={{
        resultCompany,
        requestCompany,
        setRequestCompany,
        showModal,
        setShowModal,
        selectedCompany,
        setSelectedCompany,
        loading,
        setLoading,
        updateCompany,
        createCompany,
        removeCompany,
      }}
    >
      <CompanyScreen />
    </Context.CompanyScreen.Provider>
  );
};

export default CompanyContainer;
